import { Payments } from "..";

export type PaymentInfo = {
  type?: Payments;
  bankNo?: string;
  bankId?: string | number;
  bankBranch?: string;
  provinceId?: string | number;
  cityId?: string | number;
  securePassword?: string;
  alipayAccount?: string;
  qrContent?: string;
  receiptCode?: string;
  wxRealname?: string;
};

export type PaymentItem = {
  id: number;
  info?: string;
  status?: number;
  type?: Payments;
  typeName?: string;
  ownerType?: "Member" | "Business" | "ProfessionBusiness",
  isMerchant?: boolean,
  isProfession?: boolean,
};

export type Payment = {
  text: string;
  icon: string;
  value: Payments;
  subText: string;
  label?: string
};

export const payments: Payment[] = [
  {
    text: "银行卡",
    icon: "bank",
    value: Payments.BANK,
    subText: "绑定其他银行卡",
  },
  {
    text: "微信",
    icon: "wechat",
    value: Payments.WE_CHAT,
    subText: "添加微信支付",
  },
  {
    text: "支付宝",
    icon: "alipay",
    value: Payments.ALI,
    subText: "添加支付宝支付",
  },
  {
    text: "USDT地址",
    icon: "USDT",
    value: Payments.CRYPTO_COIN,
    subText: "添加USDT地址",
  },
  {
    text: "数字人民币",
    label: '数字人民币地址',
    icon: "digital_rmb",
    value: Payments.DIGITAL_RMB,
    subText: "添加数字人民币地址",
  },
];
